import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { X, Desktop } from '@phosphor-icons/react';

/**
 * Self-provisioning QR for the Electron Photobooth Kiosk.
 * Encodes the Pocket Booth URL so the venue laptop camera can pick it up
 * directly in the kiosk setup screen — no typing required.
 */
const KioskQrModal = ({ open, onClose, pocketBoothUrl, eventName }) => {
  if (!open) return null;
  // Prefix so the kiosk can recognise this is a config payload vs. any random URL.
  const payload = `eventdrop-kiosk:${pocketBoothUrl}`;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
      data-testid="kiosk-qr-modal"
    >
      <div
        className="w-full max-w-md rounded-2xl p-6 border border-white/10"
        style={{ background: 'linear-gradient(180deg, #12152A, #0F1014)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #FF0099, #B89762)' }}
            >
              <Desktop size={20} weight="bold" className="text-white" />
            </div>
            <div>
              <h3 className="font-bold text-white text-lg leading-tight">Kiosk Setup QR</h3>
              <p className="text-xs text-gray-400">Point the venue laptop at this QR</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white/5 text-gray-400 hover:text-white transition-colors"
            aria-label="Close"
            data-testid="kiosk-qr-close"
          >
            <X size={18} weight="bold" />
          </button>
        </div>

        <div className="bg-white rounded-xl p-6 flex items-center justify-center mb-4">
          <QRCodeSVG
            value={payload}
            size={260}
            level="M"
            includeMargin={false}
            fgColor="#000000"
            bgColor="#FFFFFF"
            data-testid="kiosk-qr-code"
          />
        </div>

        <ol className="space-y-2 text-sm text-gray-300 mb-4 list-decimal list-inside">
          <li>Launch <strong className="text-white">EventDrop Photobooth</strong> on the venue laptop.</li>
          <li>On the setup screen, tap <strong className="text-white">Scan QR</strong>.</li>
          <li>Hold this screen up to the laptop camera — it auto-fills the URL and starts the kiosk.</li>
        </ol>

        <div className="rounded-xl p-3 bg-white/5 border border-white/10 text-[11px] text-gray-400 break-all">
          <span className="text-gray-500 uppercase tracking-wider font-semibold text-[9px] block mb-1">Direct URL (fallback)</span>
          <span data-testid="kiosk-qr-url">{pocketBoothUrl}</span>
        </div>

        {eventName ? (
          <p className="text-center text-[11px] text-gray-500 mt-3">
            Provisioning kiosk for <span className="text-gray-300">{eventName}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default KioskQrModal;
